import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react'; // Assuming you are using lucide-react as seen in other files
import Button from '../custom/Button'; // Adjust path to your Button component

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 px-4 text-center">
      <div className="space-y-6 max-w-md w-full">
        {/* Icon & Error Code */}
        <div className="flex flex-col items-center justify-center space-y-2">
          <AlertTriangle size={64} className="text-primary/80" />
          <h1 className="text-8xl font-bold text-primary">404</h1>
        </div>

        {/* Message */}
        <div className="space-y-2">
          <h2 className="text-2xl font-bold text-gray-800">
            Page Not Found
          </h2>
          <p className="text-gray-600">
            The page you are looking for doesn&apos;t exist or has been moved.
          </p>
        </div>

        {/* Actions */}
        <div className="flex justify-center pt-4">
          <Button 
            title="← Go Back Previous Page"
            onClick={() => navigate(-1)} // Change to your home route
            className="w-full sm:w-auto px-8"
          />
        </div>
      </div>
    </div>
  );
};

export default NotFound;